import { render, staticRenderFns } from "./admin_latest_newsList.vue?vue&type=template&id=74819d4e&scoped=true"
import script from "./admin_latest_newsList.vue?vue&type=script&lang=js"
export * from "./admin_latest_newsList.vue?vue&type=script&lang=js"
import style0 from "./admin_latest_newsList.vue?vue&type=style&index=0&id=74819d4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74819d4e",
  null
  
)

export default component.exports